<template>
  <b-alert :show="true" variant="danger">
    <div class="iq-alert-icon">
      <i class="ri-information-line"></i>
    </div>
    <div class="iq-alert-text">Access denied.</div>
  </b-alert>
</template>

<script>
export default {
  name: "AccessDenied"
};
</script>
